module.exports = __webpack_public_path__ + "static/media/radio-alt.92bba8dd.svg";